import React, {useState, useEffect, Fragment} from 'react'
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import { Formik, Form } from 'formik';
import { Link, useHistory } from 'react-router-dom';
import { updatePatient } from '../../actions/adminActions';
import ResourceOrgAssign from '../../components/Form/ResourceOrgAssign';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_PATIENT_RESET} from '../../constants/adminConstants';
import {useAlert} from 'react-alert';
import { Button, Form as CheckboxForm } from 'react-bootstrap';
import { StateSelect } from '../../components/Form/StateSelectBox';
import { formatPhone } from '../../components/Form/MaskedFields';
import Icd10Picker from '../../components/PatientForm/Icd10Picker';
import ProviderSelect from '../../components/PatientForm/ProviderSelect';
import LegacyInsurance from '../../components/PatientForm/LegacyInsurance';
import PatientDevicesSection from '../../components/PatientForm/PatientDevicesSection';
import { dobForInput, normalizeState, normalizePhone, digitsOnly, maskSsn, programsFor, validatePatientFields, providerMissingWarning } from '../../utils/patientForm';


const EditPatient = (props) => {

const alert = useAlert();
const dispatch = useDispatch();
const history = useHistory();

let patientInfo = props?.location?.state?.patientDetails;

const { _id, emrId, firstname, lastname, email, DOB, gender, phone1, address, city, line2, state, zipCode, ssn, diseases, diseasesLegacy, diagnosisCodes, insurancecompany, patientType, organizationId, assigned_doctor_id} = patientInfo;

const [pEmrId, setEmrId] = useState(emrId);
const [pFirstName, setPFirstName] = useState(firstname);
const [pLastName, setPLastName] = useState(lastname);
const [pEmail, setPEmail] = useState(email);
const [pDOB, setPDOB] = useState(dobForInput(DOB));
const [pGender, setPGender] = useState(gender);
const [pPhone1, setPPhone1] = useState(normalizePhone(phone1));
const [pAddress, setPAddress] = useState(address);
const [pCity, setPCity] = useState(city);
const [pLine2, setPLine2] = useState(line2);
const [pState, setPState] = useState(normalizeState(state) || state || '');
const [pSSN, setPSSN] = useState('');
const [ssnEditing, setSsnEditing] = useState(false);
const [pZip, setPZip] = useState(digitsOnly(zipCode).slice(0, 5));
const [pDx, setPDx] = useState((diagnosisCodes || []).filter((d) => d && d.code));
const [pProvider, setPProvider] = useState(String(assigned_doctor_id?._id || assigned_doctor_id || ''));
const [errors, setErrors] = useState({});
const legacyDiseases = diseasesLegacy || ((diagnosisCodes || []).length ? '' : diseases);
const [pPatientType, setPPatientType] = useState(patientType);
const [pOrgId, setPOrgId] = useState(organizationId?._id || organizationId || '');

const { error, isUpdated} = useSelector(state => state.admin);

    useEffect(() => {
        if(error){
            alert.error(error)
        }

        if(isUpdated){
            alert.success('Patient Updated');
            dispatch({ type: UPDATE_PATIENT_RESET});
            props.history.goBack();
        }
    },[error, isUpdated])

const initialValues = {
    deviceId: _id,
    emrId: emrId, 
    firstname: firstname, 
    lastname: lastname, 
    email: email,
    DOB: dobForInput(DOB),
    gender: gender,
    phone1:phone1,
    address:address,
    city:city,
    state:state,
    zipCode: zipCode,
    ssn:ssn,
    diseases:diseases,
    insurancecompany:insurancecompany,
    patientType: patientType,
  }

  const programs = programsFor(pPatientType);
  const providerWarning = providerMissingWarning(programs, pProvider);
  const updateHandler = () => {
      if(!pOrgId){ alert.error('Organization is required'); return }
      const errs = validatePatientFields({ city: pCity, zipCode: pZip, phone1: pPhone1, state: pState, ssn: pSSN, diagnosisCodes: pDx }, { programs, ssnTouched: ssnEditing });
      setErrors(errs);
      if (Object.keys(errs).length) { alert.error(Object.values(errs)[0]); return }
      if (providerWarning) alert.info(providerWarning);
      const stateCode = normalizeState(pState);
      dispatch(updatePatient(_id, pEmrId, pFirstName, pLastName, pEmail, pDOB || undefined, pGender, normalizePhone(pPhone1), pAddress, pCity, pLine2,
          stateCode || undefined, ssnEditing ? digitsOnly(pSSN) : undefined, undefined, undefined, pPatientType, pOrgId,
          { zipCode: pZip || undefined, diagnosisCodes: pDx.map((d) => d.code), assigned_doctor_id: pProvider || null }));
  }

return (
    <Fragment>
        <MetaData title="Edit Patient"/>
            <Sidebar />    

            <section className="home-section">
            {/* TopBar */}
            <TopBar />

            <div className="shadow-lg p-3 mb-2 mr-4 ml-4 rounded-card">
                <div className="home-content">

                <div className="row-display">
                    <div className="col-md-11">
                        <h5 style={{color: '#004aad'}}>
                            <i className="bx bx-edit"></i> <strong>&nbsp;
                                Edit Details - <span style={{color: '#222'}}>{patientInfo?.firstname} {patientInfo?.lastname} </span>
                             </strong>
                        </h5>
                    </div>

                <Button className="btn btn-secondary btn-sm" onClick={() => history.goBack()}><i className='bx bx-arrow-back' ></i></Button> &nbsp;
                <Link to="/adminDashboard" className="btn btn-secondary btn-sm"><i className='bx bx-home'></i></Link> &nbsp;


                </div>

                <hr />

                    
                    <Formik initialValues={initialValues}
                            enableReinitialize={true}
                            // validationSchema={validate}
                            onSubmit={updateHandler}
                    >
                        <div>
                            <Form>
                                <div className="row">

                                    {/* EMR ID */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="firstname" className="form-label mt-3">EMR ID</label>
                                            <input
                                                type="text" 
                                                name="emdId"
                                                className='form-control shadow-none'
                                                placeholder="EMR ID"
                                                value={pEmrId}
                                                onChange={(e) => setEmrId(e.target.value)} 
                                            />
                                    </div>

                                    {/* First Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="firstname" className="form-label mt-3">First Name</label>
                                            <input
                                                type="text" 
                                                name="firstname"
                                                className='form-control shadow-none'
                                                placeholder="First Name"
                                                value={pFirstName}
                                                onChange={(e) => setPFirstName(e.target.value)} 
                                            />
                                    </div>

                                    {/* Last Name */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="lastname" className="form-label mt-3">Last Name</label>
                                            <input
                                                type="text" 
                                                name="lastname"
                                                className='form-control shadow-none'
                                                placeholder="Last Name"
                                                value={pLastName}
                                                onChange={(e) => setPLastName(e.target.value)} 
                                            />
                                    </div>

                                    {/* Email Address */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="email" className="form-label mt-3">Email Address</label>
                                            <input
                                                type="text" 
                                                name="email"
                                                className='form-control shadow-none'
                                                placeholder="Email Address"
                                                value={pEmail}
                                                onChange={(e) => setPEmail(e.target.value)} 
                                            />
                                    </div>

                                    {/* DOB */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="dob" className="form-label mt-3">D.O.B</label>
                                            <input
                                                type="date" 
                                                name="dob"
                                                className='form-control shadow-none'
                                                placeholder="D.O.B"
                                                value={pDOB}
                                                onChange={(e) => setPDOB(e.target.value)} 
                                            />
                                    </div>

                                    {/* Gender */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label htmlFor="gender" className="form-label mt-3">Gender</label>
                                            <select
                                                label="Gender"
                                                name="gender"
                                                className="form-control"
                                                defaultValue={pGender}
                                                onChange={(e) => setPGender(e.target.value)}
                                                >
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                    </div>

                                    {/* Phone */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="phone1" className="form-label mt-3">Phone</label>
                                        <input id="phone1" type="text" inputMode="numeric" className='form-control shadow-none' placeholder="(XXX) XXX-XXXX"
                                            value={formatPhone(pPhone1)} onChange={(e) => setPPhone1(digitsOnly(e.target.value).slice(0, 10))} />
                                        {errors.phone1 ? <div className="error">{errors.phone1}</div> : null}
                                    </div>
                                    {/* Address */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="address" className="form-label mt-3">Address</label>
                                        <input id="address" type="text" className='form-control shadow-none' placeholder="Address" value={pAddress || ''} onChange={(e) => setPAddress(e.target.value)} />
                                    </div>
                                    {/* Address 2 */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="line2" className="form-label mt-3">Address 2</label>
                                        <input id="line2" type="text" className='form-control shadow-none' placeholder="Apt, suite, unit" value={pLine2 || ''} onChange={(e) => setPLine2(e.target.value)} />
                                    </div>
                                    {/* City */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="city" className="form-label mt-3">City <span style={{ color: 'red', fontWeight: 'bold' }}> *</span></label>
                                        <input id="city" type="text" className='form-control shadow-none' placeholder="City" value={pCity || ''} onChange={(e) => setPCity(e.target.value)} />
                                        {errors.city ? <div className="error">{errors.city}</div> : null}
                                    </div>
                                    {/* State */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <StateSelect value={pState} onChange={setPState} error={errors.state} />
                                    </div>
                                    {/* ZIP */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="zipCode" className="form-label mt-3">ZIP</label>
                                        <input id="zipCode" type="text" inputMode="numeric" className='form-control shadow-none' placeholder="5 digits" value={pZip} onChange={(e) => setPZip(digitsOnly(e.target.value).slice(0, 5))} />
                                        {errors.zipCode ? <div className="error">{errors.zipCode}</div> : null}
                                    </div>
                                    {/* SSN: masked, last 4 shown to editors */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <label htmlFor="ssn" className="form-label mt-3">SSN</label>
                                        {ssnEditing ? (
                                            <input id="ssn" type="text" inputMode="numeric" autoComplete="off" className='form-control shadow-none' placeholder="9 digits"
                                                value={pSSN} onChange={(e) => setPSSN(digitsOnly(e.target.value).slice(0, 9))} />
                                        ) : (
                                            <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                <input id="ssn" className='form-control shadow-none' value={maskSsn(ssn) || '—'} readOnly disabled />
                                                <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setSsnEditing(true)}>Change</button>
                                            </div>
                                        )}
                                        {errors.ssn ? <div className="error">{errors.ssn}</div> : null}
                                    </div>
                                    {/* Insurance Company (legacy, read-only) */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <LegacyInsurance text={insurancecompany} patientId={_id} />
                                    </div>
                                    {/* Diagnoses (ICD-10-CM) */}
                                    <div className="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                        <Icd10Picker value={pDx} onChange={setPDx} legacyText={legacyDiseases} error={errors.diagnosisCodes} compulsory={programs.length > 0} />
                                    </div>
                                    {/* Provider */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <ProviderSelect organizationId={pOrgId} value={pProvider} onChange={setPProvider} warning={providerWarning} />
                                    </div>
                                    {/* Organization (Session 3b) */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                        <ResourceOrgAssign kind="patient" resourceId={_id} organizationId={pOrgId} onSaved={setPOrgId} />
                                    </div>

                                    {/* isCCM */}
                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label htmlFor="isCCM" className="form-label mt-3">Patient Type</label>
                                        <select
                                            label="isCCM"
                                            name="isCCM"
                                            className="form-control"
                                            defaultValue={pPatientType}
                                            onChange={(e) => setPPatientType(e.target.value)}
                                            >
                                            <option value="RPM">RPM Patient</option>
                                            <option value="CCM">CCM Patient</option>
                                            <option value="Both">RPM & CCM</option>
                                        </select>
                                    </div>

                                </div>

                                <br/>
                                {/* Buttons */}
                                <div className="row mr-3" style={{ float: 'right'}}>
                                    <button className="edit-pill ml-3" type="submit" >Update</button>
                                </div>

                                <br/><br/><br/>
                            </Form>
                        </div>
                    </Formik>
                    <PatientDevicesSection patient={patientInfo} />
                </div>
            </div>
        </section>
    </Fragment>
  )
}

export default EditPatient